import { FocusEventHandler, FunctionComponent } from 'react'
import { useActor } from '@xstate/react'
import type { Size } from '../src/types'
import { ProductInterpreter } from '../src/machines/productMachine'
import { Select } from './Select'

type Props = {
  sizes: Size[]
  service: ProductInterpreter
  onFocus?: FocusEventHandler
}

export const SizeSelect: FunctionComponent<Props> = (props) => {
  const { sizes, service, onFocus } = props
  const [productState, productSend] = useActor(service)
  const { size } = productState.context
  const sizeOptions = sizes.map((s) => ({
    value: s,
    content: s.dropdownName || s.name,
    key: s.id,
  }))
  const setSize = (size: Size | undefined) =>
    productSend(size ? { type: 'SET', size } : { type: 'UNSET' })

  return (
    <Select
      options={sizeOptions}
      value={size}
      setValue={setSize}
      onFocus={onFocus}
      label={size?.name || 'Select Size'}
    />
  )
}
